import axios from "axios";
import { BASE_ADMIN_API_URI } from "./constant";

axios.defaults.baseURL = BASE_ADMIN_API_URI;

axios.interceptors.request.use(config => {
  const authToken = localStorage.getItem("accessToken");
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

axios.interceptors.response.use(
  response => {
    if (response.data?.status === 401) {
      localStorage.removeItem("accessToken");

      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
      return Promise.reject(new Error(response.data.message || "Unauthorized"));
    }

    // Notify the sidebar to refresh the free-session count after any API call.
    // Skip the count endpoint itself to avoid an infinite loop.
    if (!response.config?.url?.includes("freesessionrequest/count")) {
      window.dispatchEvent(new CustomEvent("api-response-received"));
    }

    return response.data;
  },
  error => {

    if (!error.response) {
      return Promise.reject(error);
    }

    const { status } = error.response;

    if (status === 401) {
      localStorage.removeItem("accessToken");
      window.location.href = "/login";
      return;
    }

    return Promise.reject(error);
  }
);



export const apiRequest = async ({ method, url, req, params }) => {
  try {
    if (method === "get") return await axios[method](url, params);
    return await axios[method](url, req, params);
  } catch (error) {
    if (error.response?.data) {
      return error.response.data;
    }
    return { error: error.message };
  }
};


export const getApi = async (url, params) => await apiRequest({ method: "get", url, params });
export const postApi = async (url, req, params) => await apiRequest({ method: "post", url, req, params });
export const putApi = async (url, req, params) => await apiRequest({ method: "put", url, req, params });
export const deleteApi = async (url, req, params) => await apiRequest({ method: "delete", url, params });
export const patchApi = async (url, req, params) => await apiRequest({ method: "patch", url, req, params });
